import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BaseComponent } from '@zero/self-service/feature-self-service/web';
import { FormateIBANPipe } from '@zero/shared/ui-pipes';
import { CopyToClipboardComponent, DividerComponent } from '@zero/shared/ui-web-design-system';
import { MoneyTransactionComponent } from '../account-overview/money-transaction/money-transaction.component';

@Component({
  templateUrl: './deposit.component.html',
  imports: [CopyToClipboardComponent, MoneyTransactionComponent, TranslocoPipe, FormateIBANPipe, AsyncPipe, DividerComponent],
})
export class DepositComponent extends BaseComponent {}
